import React, { useEffect, useState } from 'react';
import {
  Create,
  SimpleForm,
  useDataProvider,
  useNotify,
  Toolbar,
  SaveButton,
} from 'react-admin';
import RecyclingsFormFields from '../customForms/RecyclingsFormFields';

const CustomToolbar = () => {
  const notify = useNotify();

  const onSuccess = (data) => {
    if (data?.message) {
      notify(data.message, { type: 'info' });
    } else {
      notify('Recycling created.', { type: 'info' });
    }
  };

  return (
    <Toolbar>
      <SaveButton mutationOptions={{ onSuccess }} />
    </Toolbar>
  );
};

const RecyclingsCreate = () => {
  const dataProvider = useDataProvider();
  const [fileOptions, setFileOptions] = useState({ Pdfs: [], Images: [], Videos: [] });

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const result = await dataProvider.listFiles?.();
        const allFiles = [
          ...(result?.Pdfs || []),
          ...(result?.Images || []),
          ...(result?.Videos || []),
        ];

        setFileOptions({
          Pdfs: allFiles.filter((f) => f.toLowerCase().endsWith('.pdf')),
          Videos: allFiles.filter((f) => f.toLowerCase().endsWith('.mp4')),
          Images: allFiles.filter(
            (f) => !f.toLowerCase().endsWith('.pdf') && !f.toLowerCase().endsWith('.mp4')
          ),
        });
      } catch (err) {
        console.error('Failed to fetch files', err);
      }
    };

    fetchFiles();
  }, [dataProvider]);

  return (
    <Create title="Novo Componente" redirect="edit">
      <SimpleForm toolbar={<CustomToolbar />}>
        <RecyclingsFormFields fileOptions={fileOptions} />
      </SimpleForm>
    </Create>
  );
};

export default RecyclingsCreate;
